import {makeStyles} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  default_padding: {
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(5),
  },
  custom_textfield: {
    '& .MuiFilledInput-root': {
      background: 'rgb(255,255,255)',
    },
  },
  hide: {
    display: 'none !important',
  },
  sideBySide: {
    gridTemplateColumns: '30% 1fr',
  },
  fullRow: {
    gridTemplateColumns: `1fr`,
  },
  errorButton: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.error.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.error.dark,
      borderColor: theme.palette.error.dark,
    },
  },

  grid_searchbar_button: {
    display: 'grid',
    gridTemplateColumns: '1fr auto',
    alignItems: 'center',
    marginBottom: 24,
  },
  custom_button: {
    fontWeight: 600,
    textTransform: 'none',
  },
  row_btw: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  gray_background: {
    backgroundColor: theme.palette.grey[50],
  },
  dialog_title: {
    fontSize: 21,
    fontWeight: 600,
    lineHeight: '25.41px',
    margin: 0,
  },
  dialog_subtitle: {
    fontSize: 12,
    lineHeight: '14.52px',
    color: theme.palette.grey[500],
    marginBottom: 10,
  },
  tab_title: {
    fontSize: 16,
    textTransform: 'none',
  },
  fieldGroup: {
    marginTop: '1rem',
    marginBottom: '0.5rem',
  },
  form: {
    paddingBottom: '4rem',
  },
  formHelperText: {
    fontSize: '14px',
    fontWeight: 600,
  },
  sponsor: {
    width: '100%',
    height: 130,
    position: 'relative',
    borderRadius: 8,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: `2px dashed ${theme.palette.primary}`,
  },
}));

export default useStyles;
